import { render, staticRenderFns } from "./TableStockDetail.vue?vue&type=template&id=88045b4e&scoped=true&"
import script from "./TableStockDetail.vue?vue&type=script&lang=js&"
export * from "./TableStockDetail.vue?vue&type=script&lang=js&"
import style0 from "./TableStockDetail.vue?vue&type=style&index=0&id=88045b4e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88045b4e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
